/* ==========================================================================
   The main photo follows the lid and the ribbon

   On the Biscotti page the jar's lid is a line-item property, not a Shopify
   option, so the variant photo (which follows the ribbon) always showed one
   fixed lid: pick Matte Black and the photo still showed Brushed Nickel.

   The lid block can carry a table of photos, one per lid + ribbon pair
   ("Photos per lid and ribbon", rendered as #gioLidRibbonPhotos). Once a lid
   is picked, the photo for that lid with the chosen ribbon is shown; when the
   ribbon then changes, the theme first puts the ribbon's variant photo up and
   this puts the matching lid back on top of it.

   It holds for as long as a lid is chosen, whatever puts a photo up after
   it (a ribbon or flavour change, however slow the connection), and steps
   aside while the shopper browses the thumbnails; the next pick brings it
   back.
   ========================================================================== */
(function () {
  'use strict';

  // True after a thumbnail or gallery arrow is used, until the next pick.
  var browsing = false;

  function table() {
    var el = document.getElementById('gioLidRibbonPhotos');
    if (!el) return null;
    try {
      var rows = JSON.parse(el.textContent);
      return Array.isArray(rows) && rows.length ? rows : null;
    } catch (e) {
      return null;
    }
  }

  function norm(s) {
    return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function same(a, b) {
    a = norm(a);
    b = norm(b);
    return !!a && !!b && (a === b || a.indexOf(b) === 0 || b.indexOf(a) === 0);
  }

  function lidChosen() {
    var w = document.getElementById('lidDropdown');
    if (!w || !w.classList.contains('chosen')) return '';
    var o = w.querySelector('.fd-option.selected');
    return o ? (o.getAttribute('data-label') || o.getAttribute('data-value') || '') : '';
  }

  function ribbonChosen() {
    var w = document.getElementById('giftWrapDropdown');
    var o = w && w.querySelector('.fd-option.selected');
    return o ? (o.getAttribute('data-value') || o.getAttribute('data-label') || '') : 'No Ribbon';
  }

  // "…/files/84_1200x.png?v=1" and "…/files/84.png?v=1&width=900" are one photo.
  function key(src) {
    var file = String(src || '').split('?')[0].split('/').pop();
    return file.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z]+$)/i, '').toLowerCase();
  }

  function target() {
    var rows = table();
    var lid = lidChosen();
    if (!rows || !lid) return null;
    var ribbon = ribbonChosen();
    for (var i = 0; i < rows.length; i++) {
      if (same(rows[i].lid, lid) && same(rows[i].ribbon, ribbon) && rows[i].src) return rows[i].src;
    }
    return null;
  }

  function apply() {
    var src = target();
    var hero = document.getElementById('heroImg');
    if (!src || !hero || typeof window.showVariantHero !== 'function') return;
    if (key(hero.getAttribute('src')) === key(src)) return;
    window.showVariantHero(src, '');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.thumb-col img, #heroArrowPrev, #heroArrowNext')) {
      browsing = true;
      return;
    }
    if (e.target.closest('.fd-option, .fd-collection-row, .pkg-card')) {
      browsing = false;
      setTimeout(apply, 60);
      setTimeout(apply, 700);
    }
  });

  // Whatever replaces the photo afterwards (the ribbon's or flavour's variant
  // photo arrives after its own fetch), the lid goes back on top of it. Every
  // write is skipped once the photo is right, so this cannot feed itself.
  function watch() {
    var hero = document.getElementById('heroImg');
    if (!hero || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (browsing) return;
      setTimeout(apply, 30);
    }).observe(hero, { attributes: true, attributeFilter: ['src'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
